// test733
(733 && 0);
